import {createContext, useContext} from "react";
import {connect} from "react-redux";
import {linkkipalveluSelector} from "../../../../../../data/selector";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {isEmpty} from 'lodash';
import {getDepartmentabbreviation, hasLinkValue} from "../../../../../../utils/TimelineUtils";

export const TimelineFrameCareUnitContext = createContext(null);
const TimelineFrameContentCareUnitWrapper = ({children, linkkipalvelu}) => {
    const { data } = useContext(TimelineFrameDataContext);

    const isCoxa = () => {
        if(linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid] === 'fetching' ||
            linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid] === undefined) {
            return false;
        }
        const c = linkkipalvelu.Logot && linkkipalvelu.Logot[data.oid];
        return "COXA" === c[0].toString();
    }

    const attemptToGetLinkValue = (departmentAbbr) => {
        return linkkipalvelu.Toimipistetiedot &&
            linkkipalvelu.Toimipistetiedot[departmentAbbr];
    }

    const getConditionalRenderForCareUnitLinkData = () => {
        const coxa = isCoxa();
        if (coxa) {
            return (
                <TimelineFrameCareUnitContext.Provider value={{coxa}}>
                    {children}
                </TimelineFrameCareUnitContext.Provider>
            );
        }
        if (!isEmpty(data.department)) {
            const linkValue = attemptToGetLinkValue(getDepartmentabbreviation(data.department));
            const hasLink = hasLinkValue(linkValue);
            if (hasLink) {
                return (
                    <TimelineFrameCareUnitContext.Provider value={{linkValue, hasLink}}>
                        {children}
                    </TimelineFrameCareUnitContext.Provider>
                );
            }
        }
        return null;
    }

    return getConditionalRenderForCareUnitLinkData();
}

const mapStateToProps = (state) => {
    let linkkipalvelu = linkkipalveluSelector(state);
    return {
        linkkipalvelu
    }
}

export default connect(mapStateToProps)(TimelineFrameContentCareUnitWrapper);